

function ProjectsPage() {
  return (
    <div>
      <h1>Projects</h1>
    </div>
  );
}

export default ProjectsPage;